import {initWebComponent} from "@/helpers/web-component-helper";
import {toggleAccordionCollapse} from "@/helpers/bootstrap-accordion-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {clearLayerSearch} from "@/helpers/layer/menu/layer-search-helper.js";
import {hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper.js";

const template = document.createElement('template');

template.innerHTML =  `
<div class="form-inline mb-2 bg-lighter">
    <div class="input-group w-100">
        <span class="input-group-prepend">
          <span class="fa fa-search text-secondary"></span>
        </span>
        <input class="form-control mr-sm-2 iptSearchLayer" type="text" style="border-bottom: 0px">
        <span id="iptSearchLayerClear" class="fa fa-times position-absolute cursor-pointer d-none" style="right: 85px;top: 12px;z-index: 100;font-size:10px">
        </span>
        <span class="input-group-append">
          <layer-menu-overview-collapse data-collapse="true" data-accordion-class="layer-menu"></layer-menu-overview-collapse>
        </span>
        <span class="input-group-append">
          <layer-menu-overview-collapse data-collapse="false" data-accordion-class="layer-menu"></layer-menu-overview-collapse>  
        </span>
        <span class="input-group-append">
          <layer-menu-overview-reset></layer-menu-overview-reset>
        </span>
    </div>
</div>`

export class LayerMenuSearchComponent extends HTMLElement{
    constructor(){
        super();

        initWebComponent(this, template)

        const element = document.getElementsByClassName('iptSearchLayer')[0]
        if(!element) {
            return
        }

        this.querySelector('#iptSearchLayerClear').addEventListener('click', () => {
            element.value = ''
            clearLayerSearch()
            hideElementsBySelector('#iptSearchLayerClear')
        })

        element.addEventListener('keyup', (e) => {

            e.preventDefault()


            const value = String(e.target.value).toLowerCase()

            const menuOverView = document.querySelector('layer-menu-overview')

            if(value === "") {
                hideElementsBySelector('#iptSearchLayerClear')
                clearLayerSearch()
                return
            }

            showElementsBySelector('#iptSearchLayerClear')

            toggleAccordionCollapse('layer-menu', false)

            menuOverView.querySelectorAll('layer-menu-group-item, layer-menu-group-merged').forEach( element => {
                const bookmarkPresentation = getBranchItemByBookmarkPresentationID(element.dataset.id)
                if(
                    String(element.dataset.label).toLowerCase().includes(value) ||
                    (bookmarkPresentation && bookmarkPresentation.Tags && bookmarkPresentation.Tags.toLowerCase().includes(value))
                ) {
                    element.classList.remove('d-none')
                } else {
                    element.classList.add('d-none')
                }
            })

            menuOverView.querySelectorAll('layer-menu-group').forEach( layerMenuGroup => {
                let visible = false

                if (
                    String(layerMenuGroup.dataset.label).toLowerCase().includes(value)
                ) {
                    visible = true
                    const parent = layerMenuGroup.parentElement.closest('layer-menu-group')
                    if (parent) {
                        parent.classList.remove('d-none')
                    }
                    layerMenuGroup.querySelectorAll('layer-menu-group-item').forEach(layerMenuGroupItem => {
                        layerMenuGroupItem.classList.remove('d-none')
                    })
                }

                layerMenuGroup.querySelectorAll('layer-menu-group-item').forEach(layerMenuGroupItem => {
                    if (!layerMenuGroupItem.classList.contains('d-none')) {
                        visible = true
                    }
                })

                if (visible) {
                    layerMenuGroup.classList.remove('d-none')
                } else {
                    layerMenuGroup.classList.add('d-none')
                }
            })
        });
    }
}
